import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import { getUser, getUser_v2 } from '../utils/dropdownlist'
import { MdDone, MdWarning, MdModeEdit } from 'react-icons/md'
import { FaEdit } from 'react-icons/fa'
import { IconContext } from 'react-icons/lib'

const scolumn = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Invoice',
    field: 'invoice_no',
    sort: 'asc',
  },
  {
    label: 'Type',
    field: 'order_type',
    sort: 'asc',
  },
  {
    label: 'Service',
    field: 'service_type',
    sort: 'asc',
  },
  {
    label: 'Price($)',
    field: 'total_price',
    sort: 'asc',
  },
  {
    label: 'Tax($)',
    field: 'total_tax',
    sort: 'asc',
  },
  {
    label: 'Schedule',
    field: 'schedule',
    sort: 'asc',
  },
  {
    label: 'Payment',
    field: 'payment_status',
    sort: 'asc',
  },
  {
    label: 'Order Date',
    field: 'order_dt',
    sort: 'asc',
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

const pcolumn = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Invoice',
    field: 'invoice_no',
    sort: 'asc',
  },
  {
    label: 'Type',
    field: 'order_type',
    sort: 'asc',
  },
  {
    label: 'Service',
    field: 'service_type',
    sort: 'asc',
  },
  {
    label: 'Price($)',
    field: 'total_price',
    sort: 'asc',
  },
  {
    label: 'Tax($)',
    field: 'total_tax',
    sort: 'asc',
  },
  {
    label: 'Schedule',
    field: 'schedule',
    sort: 'asc',
  },
  {
    label: 'Payment',
    field: 'payment_status',
    sort: 'asc',
  },
  {
    label: 'Order Date',
    field: 'order_dt',
    sort: 'asc',
  },
  {
    label: 'Task To',
    field: 'task_to',
    sort: 'asc',
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class TaskOrder extends React.Component {
  _isMounted = true

  orderDetail = StorageService.getSession('taskOrder')
  constructor(props) {
    super(props)
    this.state = {
      taskModal: false,
      tabList: [{ name: 'In Progress' }, { name: 'Schedule' }],
      status: this.orderDetail && this.orderDetail.status ? this.orderDetail.status : 'In Progress',
      activeTab: '1',
      orderList: [],
      date: this.orderDetail && this.orderDetail.date ? this.orderDetail.date : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      showAll: this.orderDetail && this.orderDetail.showAll ? this.orderDetail.showAll : false,
      order_id: '',
      selectedId: '',
      task_to: '',
      userList: [],
    }
  }

  taskModal = (order_id, task_to) => () => {
    return this.setState({
      taskModal: !this.state.taskModal,
      order_id: order_id,
      selectedId: task_to,
    })
  }

  taskHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  changeHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.orderDetail ? this.orderDetail : {}
    data[name] = value
    StorageService.setSession('taskOrder', data)
    this.orderDetail = StorageService.getSession('taskOrder')
    if (value === 'In Progress') value = 'task'
    this.getOrder(value.toLowerCase(), this.state.showAll)
  }

  dateHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.orderDetail ? this.orderDetail : {}
    data[name] = value
    StorageService.setSession('taskOrder', data)
    this.orderDetail = StorageService.getSession('taskOrder')
    this.getOrder('schedule', this.state.showAll, value)
  }

  checkHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
    console.log(this.orderDetail)
    let data = this.orderDetail ? this.orderDetail : {}
    data[name] = !this.state[name]

    StorageService.setSession('taskOrder', data)
    this.orderDetail = StorageService.getSession('taskOrder')
    this.getOrder('schedule', !this.state[name])
  }

  componentDidMount() {
    let value = this.state.status === 'In Progress' ? 'task' : 'schedule'
    this.getOrder(value, this.state.showAll)
    this.getUser()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getOrder(type, showAll = false, date = null) {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.state.store_id,
    }

    if (type === 'schedule') {
      if (date) {
        data.date = date
      } else {
        data.date = moment(this.state.date).tz('Asia/Singapore').format('DD/MM/YYYY')
      }

      data.showall = showAll ? '1' : '0'
    }

    axios
      .post(url + ':3003/v1/order/' + type, data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.order_dt) {
              i.order_dt = moment(i.order_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
            }
            if (i.invoice_no === null) {
              i.invoice_no = ''
            }
            if (i.total_tax) {
              i.total_tax = parseFloat(i.total_tax).toFixed(2)
            }

            i.schedule = i.schedule_date + ' ' + i.starttime + '/' + i.endtime
            i.task_to = (
              <div className="ps-unity-nowrap">
                {i.task_to}{' '}
                <Button color="link" style={{ padding: '0px 0px 5px 0px' }} onClick={this.taskModal(i.order_id, i.task_to)}>
                  <IconContext.Provider value={{ color: '#2a2c6b' }}>
                    <FaEdit size={16} />
                  </IconContext.Provider>
                </Button>
              </div>
            )
            i.Action = (
              <div className="ps-action-button">
                <Button className="theme-button theme-button-secondary" onClick={() => this.props.order(i.order_id)}>
                  View
                </Button>
              </div>
            )
          }
          this.setState({
            orderList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  taskto = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.state.store_id,
      order_id: this.state.order_id,
      task_to: this.state.selectedId,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/taskto', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Task user updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ taskModal: false })
        let value = this.state.status === 'In Progress' ? 'task' : 'schedule'
        this.getOrder(value, this.state.showAll)
      })
      .catch(error => {
        alert(error)
      })
  }

  getUser() {
    getUser_v2()
      .then(result => {
        if (this._isMounted) {
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }
          this.setState({
            userList: result.data.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  order = id => {
    this.props.history.push({
      pathname: '/posorder/store/' + this.state.store_id + '/' + id,
    })
  }

  render() {
    const { activeTab } = this.state
    const data = {
      columns: pcolumn,
      rows: this.state.orderList,
    }
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <Row>
          <Col sm={3}>
            <Input className="ps-input-small" type="select" name="status" value={this.state.status} onChange={this.changeHandler}>
              {this.state.tabList.map(item => {
                return (
                  <option key={item.name} value={item.name}>
                    {item.name}
                  </option>
                )
              })}
            </Input>
          </Col>
          {this.state.status === 'Schedule' && (
            <>
              <Col sm={3}>
                <Input className="ps-input-small" type="date" name="date" onChange={this.dateHandler} value={this.state.date} />
              </Col>
              <Col sm={3}>
                <FormGroup check>
                  <Label check>
                    <Input type="checkbox" name="showAll" onChange={this.checkHandler} checked={this.state.showAll} /> Show All
                  </Label>
                </FormGroup>
              </Col>
            </>
          )}
        </Row>
        <MDBDataTableV5 className="ps-order-table" data={data} displayEntries={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive />
        <Modal isOpen={this.state.taskModal} toggle={this.taskModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.taskto}>
            <ModalHeader toggle={this.taskModal()}>Task To</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="select" name="selectedId" value={this.state.selectedId} onChange={this.taskHandler}>
                      <option></option>
                      {this.state.userList.map(item => {
                        return (
                          <option key={item.user_id} value={item.name}>
                            {item.name}
                          </option>
                        )
                      })}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </>
    )
  }
}

export default TaskOrder
